var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-menu"},[_c('div',{staticClass:"first"}),_c('div',{staticClass:"second"},[_c('ps-button',{attrs:{"full-width":"","text-centered":""},on:{"click":function($event){return _vm.$emit("close")}}},[_vm._v("閉じる")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }